var ajaxObject = null;
var refreshIntervalId = null;
var recursiveCall = false;

function populateDropdownOnPageLoad() {
    var locationNodeId = 0;
    if (document.getElementById('hsform')) {
        var countryDDL = document.getElementById('hsform').hscountry;
        
        if (countryDDL.length > 0) {
            for (var i = 0; i < countryDDL.length; i++) {
                if (countryDDL.options[i].selected) {
                    locationNodeId = countryDDL.options[i].value;
                    break;
                }
            }
        }
		
        if (locationNodeId) {
            populateDropdown(locationNodeId);
        }
    }    
}

function populateDropdown(locationNodeId) {    
	if(locationNodeId > 0){
		sendAjaxAvailabilityRequest(locationNodeId);
	}
}

function sendAjaxAvailabilityRequest(locationNodeId){
	if (window.XMLHttpRequest){
		// W3C method
		ajaxObject = new XMLHttpRequest();
	}else if (window.ActiveXObject){
		// IE method
		ajaxObject = new ActiveXObject('Microsoft.XMLHTTP');
	}else{
		return;
	}

	ajaxObject.onreadystatechange = updateAvailability;

	var locationDDL = document.getElementById('hsform').location;
	var subLocationDDL = document.getElementById('hsform').sublocation;
	
	addOption(locationDDL, 'Loading...', '')
	selectedIndex = locationDDL.options.selectedIndex;

	for (var i = 0; i < locationDDL.length; i++){
		if(locationDDL.options[i].text == 'Loading...' && locationDDL.options[i].value == ''){
			locationDDL.options[i].selected = true;
		}
	}

	if(!recursiveCall){
		removeAllOptions(subLocationDDL);
	}
	addOption(subLocationDDL, 'Loading...', '')
			
	ajaxObject.open('GET', '/utility/hotelajaxdropdowns.aspx?locationid=' + locationNodeId, true);
	ajaxObject.send('');
}

function updateAvailability(){
	if (ajaxObject.readyState == 4){		
		pausecomp(500);
		var locations = ajaxObject.responseXML.getElementsByTagName('Location');	
		var newSearchId = ajaxObject.responseXML.firstChild.getAttribute('SearchLocationId');
		var searchCountryId = ajaxObject.responseXML.firstChild.getAttribute('HotelCountryId');	
		var locationDDL = document.getElementById('hsform').location;
		var subLocationDDL = document.getElementById('hsform').sublocation;
		
		if(selectedIndex > 0){locationDDL.options[selectedIndex].selected = true;}

		for (var i = 0; i < subLocationDDL.length; i++){
			if(subLocationDDL.options[i].text == 'Loading...' && subLocationDDL.options[i].value == ''){
				subLocationDDL.options[i] = null;
			}
		}
		for (var i = 0; i < locationDDL.length; i++){
			if(locationDDL.options[i].text == 'Loading...' && locationDDL.options[i].value == ''){
				locationDDL.options[i] = null;
			}
		}
		for (var i = 0; i < locationDDL.length; i++){
			if(locationDDL.options[i].text == 'Loading...' && locationDDL.options[i].value == ''){
				locationDDL.options[i] = null;
			}
		}
		
		if(document.getElementById('hscountry').value != document.getElementById('countrysearch').value && !recursiveCall){
			//COUNTRY CHANGED SO DELETE ALL OPTIONS IN BOTH SELECT BOXES
			removeAllOptions(locationDDL);
			removeAllOptions(subLocationDDL);
		}

		if(document.getElementById('hsform').location.options.length <= 1 && searchCountryId == 0){			
			document.getElementById('countrysearch').value = newSearchId;
			removeAllOptions(locationDDL);
			if(!recursiveCall){
				removeAllOptions(subLocationDDL);
			}
			var selectbox = document.getElementById('hsform').location;
			if(locations.length > 0){
				for (var i = 0; i < locations.length; i++){
					var locationName = locations[i].firstChild.lastChild.nodeValue;
					var locationNodeId = locations[i].firstChild.nextSibling.lastChild.nodeValue;					
					if(i == 0){addOption(selectbox, '<Please Select>', '');}
					addOption(selectbox, locationName, locationNodeId);
					if(locationDDL.options[i].value == newSearchId && !recursiveCall){
						locationDDL.options[i].selected = true;
					}else if(recursiveCall && locationDDL.options[i].value == recursiveCallId){
						locationDDL.options[i].selected = true;
					}
				}
				selectbox.disabled = false;
				if(searchCountryId != 0 || recursiveCall){					
					var countryDDL = document.getElementById('hsform').country;
					for (var i = 0; i < countryDDL.length; i++){
						if(countryDDL.options[i].value == searchCountryId || (recursiveCall && countryDDL.options[i].value == newSearchId)){
							countryDDL.options[i].selected = true;					
						}
					}
				}				
			}else{
				addOption(selectbox, '<Any>', '');
				addOption(document.getElementById('hsform').sublocation, '<Any>', '');
			}
		}else{
			removeAllOptions(document.getElementById('hsform').sublocation);
			var selectbox = document.getElementById('hsform').sublocation;
			var locationDDL = document.getElementById('hsform').location;
			if(locations.length > 0){				
				for (var i = 0; i < locations.length; i++){
					var locationName = locations[i].firstChild.lastChild.nodeValue;
					var locationNodeId = locations[i].firstChild.nextSibling.lastChild.nodeValue;				
					if(i == 0){addOption(selectbox, '<Please Select>', '');}
					addOption(selectbox, locationName, locationNodeId);					
					if(locationDDL.options.length > i && locationDDL.options[i].value == newSearchId){
						locationDDL.options[i].selected = true;					
					}
				}
				if(locationDDL.options.length == 0 && searchCountryId != 0){
					recursiveCall = true;
					recursiveCallId = newSearchId;
					populateDropdown(searchCountryId);
				}
				selectbox.disabled = false;									
			}else{
				addOption(selectbox, '<Any>', '');
			}
		}						
	}
}

function addOption(selectbox,text,value){
	var optn = document.createElement("OPTION");
	optn.text = text;
	optn.value = value;
	selectbox.options.add(optn);	
}

function removeAllOptions(selectbox){
	selectbox.innerHTML = "";
	selectbox.disabled = true;
}

function pausecomp(millis){
	var date = new Date();
	var curDate = null;

	do { curDate = new Date(); } 
	while(curDate-date < millis);
}

function changeHotelFormAction(forceHoteldescription) {
    if (forceHoteldescription || document.getElementById('hsform').action.indexOf('hoteldescription.aspx') != -1) {
        var globalPropertyNodeId = document.getElementById('globalpropertynodeid').value;
        var hsArrival = document.getElementById('hsarrival').value;
        var roomType = document.getElementById('hsroomtype').value;
        var hsNoNights = document.getElementById('hsnonights').value;
        document.getElementById('hsform').action = '/hotels/hoteldescription.aspx?globalpropertynodeid=' + globalPropertyNodeId + '&hsarrival=' + hsArrival + '&roomtype=' + roomType + '&nights=' + hsNoNights;
    } else {
        document.getElementById('hsform').action = '/hotels/getrates.aspx';
    }
}


var FilterHotelSearch = {

    validateSubmission: function () {

        //THIS IS DEFINED IN ANOTHER PAGE DO NOT OVERWRITE: IT IS USED WHEN YOU SEARCH FOR A MARKETING REPORT (ROBCAHOON 15/11/2012)
        if (document.getElementById('removenewsearchtype').value == 'Y') {
            this.IsNewSearch = false;
            this.SearchForLocationNodeId = 0;
        } else {
            this.IsNewSearch;
            this.SearchForLocationNodeId;
        }
        ////////////////////

        if (document.getElementById('globalpropertyid') && document.getElementById('hsarrival') && document.getElementById('hsnonights') && document.getElementById('hsroomtype')) {
            this.SubmissionAjaxObject = null;
            this.HSarrival = (document.getElementById('hsarrival').value.length > 0) ? document.getElementById('hsarrival').value : '';
            this.HSnonight = (document.getElementById('hsnonights').value.length > 0) ? document.getElementById('hsnonights').value : '';
            this.HSroomtype = (document.getElementById('hsroomtype').value.length > 0) ? document.getElementById('hsroomtype').value : '';
            this.HSglobalpropertyid = (document.getElementById('globalpropertyid').value.length > 0) ? document.getElementById('globalpropertyid').value : '';
            this.HSlocation = (document.getElementById('location').value.length > 0) ? document.getElementById('location').value : '';
            this.HSpagetype = (document.getElementById('pagetype').value.length > 0) ? document.getElementById('pagetype').value : '';
            this.ErrorMessage = '';


            if (this.HSarrival.length === 0) {
                this.ErrorMessage = 'Please select the arrival day. \n';
            }

            if (this.HSnonight.length === 0) {
                this.ErrorMessage = 'Please select the number of nights. \n';
            }

            if (this.HSroomtype.length === 0) {
                this.ErrorMessage = 'Please select the room type. \n';
            }

            if (this.HSglobalpropertyid.length === 0) {
                this.ErrorMessage = 'Server error: no globalpropertyid. \n';
            }

            if (this.HSlocation.length === 0) {
                this.ErrorMessage = 'Server error: no locationid. \n';
            }

            if (this.ErrorMessage.length === 0) {
                if (this.HSpagetype == 'results') {
                    document.getElementById('hsearchform').submit();
                } else {
                    document.getElementById('pricechecking').style.display = 'block';
                    this.sendFormSubmissionAJAXRequest();
                }

            } else {
                window.alert('Reminder: \n' + this.ErrorMessage);
                return false;
            }

        }
    },

    sendFormSubmissionAJAXRequest: function () {
        'use strict';
        this.SubmissionAjaxObject = this.createAjaxObject();
        this.SubmissionAjaxObject.onreadystatechange = function () {
            try {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        if (this.responseText) {
                            document.getElementById('pricechecking').style.display = 'none';
                            var root = this.responseXML.getElementsByTagName('PriceByPropertyAndDated');
                            document.getElementById('hotelpricecheckresult').innerHTML = root[0].childNodes[0].childNodes[0].nodeValue
                            //CREATE SAVING INFORMATION FOR HOTEL DESCRIPTION 
                            if (root[0].getElementsByTagName('SavingMessage').length > 0) {
                                FilterHotelSearch.createSavingInfo(root[0].getElementsByTagName('SavingMessage'));
                            }
                        } else {
                            document.getElementById('hotelpricecheckresult').innerHTML = 'We are currently unable to give an accurate price for the dates requested. Please call us now for assistance.';
                        }
                    } else if (this.status === 500) {
                        document.getElementById('hotelpricecheckresult').innerHTML = 'We are currently unable to give an accurate price for the dates requested. Please call us now for assistance.';
                        document.getElementById('pricechecking').style.display = 'none';
                    }
                }
            } catch (err) {
                document.getElementById('pricechecking').style.display = 'none';
                document.getElementById('hotelpricecheckresult').innerHTML = 'We are currently unable to give an accurate price for the dates requested. Please call us now for assistance.';
            }
        };

        //IF YOU'VE JUST WASTED 3 HOURS TRYING TO WORK OUT WHERE THIS XML IS GENERATED TRY FilterHotelResults.ascx!
        this.SubmissionAjaxObject.open('GET', '/hotels/hoteldescription.aspx?mode=returnxml&location=' + this.HSlocation + '&globalpropertyid=' + this.HSglobalpropertyid + '&hsarrival=' + this.HSarrival + '&nights=' + this.HSnonight + '&roomtype=' + this.HSroomtype + '&newSearch=' + this.IsNewSearch + '&searchForLocationNodeId=' + this.SearchForLocationNodeId, true);

        if (document.getElementById('removenewsearchtype').value == 'N') {
            document.getElementById('removenewsearchtype').value = 'Y';
        }

        this.SubmissionAjaxObject.send('');
    },

    createAjaxObject: function () {
        'use strict';
        if (window.XMLHttpRequest) {
            return new XMLHttpRequest();
        } else if (window.ActiveXObject) {
            return new ActiveXObject('Microsoft.XMLHTTP');
        } else {
            return;
        }
    },

    //THIS IS ONLY FOR HOTEL DESCRIPTION DISCOUNT/SAVING
    createSavingInfo: function (saving) {
        var savingHolder = document.getElementById('savingholder');
        if (savingHolder) {
            $("#savingholder").addClass("showme");
            savingHolder.innerHTML = $(saving).text();
        }
    }
}

////////////// HOTELS ASYNCHRONOUSLY /////////////
function getHotels(hotelDisplayMode, starRating, numHotelsToDisplay, webLocationId, obj) {

    var mainHotelHolder;

    if (starRating > 0 && numHotelsToDisplay > 0 && webLocationId > 0) {
        
        switch (starRating) {
            case 5:
                mainHotelHolder = document.getElementById('fiveStarHotelHolder');
                mainHotelHolder.style.display = 'block';
                $("#loading5star").show();
                break;
            case 4:
                mainHotelHolder = document.getElementById('fourStarHotelHolder');
                mainHotelHolder.style.display = 'block';
                $("#loading4star").show();
                break;
            case 3:
                mainHotelHolder = document.getElementById('threeStarHotelHolder');
                mainHotelHolder.style.display = 'block';
                $("#loading3star").show();
                break;
            case 2:
                mainHotelHolder = document.getElementById('budgetStarHolder');
                mainHotelHolder.style.display = 'block';
                $("#loadingbudgetstar").show();
            default:
                mainHotelHolder = document.getElementById('budgetStarHolder');
                mainHotelHolder.style.display = 'block';
                $("#loadingbudgetstar").show();

        }

        switch (obj) {
            case 'ctl00_leftContent_fivestarhead':
                clearPosition = 'Y';
                if (document.getElementById('fiveStarHotelHolderDisplay')) {
                    document.getElementById('fiveStarHotelHolderDisplay').style.padding = '0px';
                    document.getElementById('fiveStarHotelHolderDisplay').style.margin = '0px';
                }
                if (document.getElementById('showMore5')) {
                    document.getElementById('showMore5').style.display = 'none';
                }
        
                break;
            case 'ctl00_leftContent_fourstarhead':
                clearPosition = 'Y';
                if (document.getElementById('fourStarHotelHolderDisplay')) {
                    document.getElementById('fourStarHotelHolderDisplay').style.padding = '0px';
                    document.getElementById('fourStarHotelHolderDisplay').style.margin = '0px';
                }
                if (document.getElementById('showMore4')) {
                    document.getElementById('showMore4').style.display = 'none';
                }
                break;
            case 'ctl00_leftContent_threestarhead':
                clearPosition = 'Y';
                if (document.getElementById('threeStarHotelHolderDisplay')) {
                    document.getElementById('threeStarHotelHolderDisplay').style.padding = '0px';
                    document.getElementById('threeStarHotelHolderDisplay').style.margin = '0px';
                }
                if (document.getElementById('showMore3')) {
                    document.getElementById('showMore3').style.display = 'none';
                }
                break;
            case 'ctl00_leftContent_budgetstarhead':
                clearPosition = 'Y';
                break;
            default:
                clearPosition = 'N';
        }

        if (mainHotelHolder) {
            mainHotelHolder.style.display = 'block';
        }

        if (obj) {
            if (document.getElementById(obj)) {
                document.getElementById(obj).style.minHeight = 'auto';
            } else {
                mainHotelHolder.style.display = 'none';
            }
        }


        if (hotelDisplayMode.toUpperCase() === 'D') {
            clearPosition = 'Y';
        }

        jQuery.ajax({
            url: '/utility/hotelresultsbystarrating.aspx?starrating=' + starRating + '&numhotelstodisplay=' + numHotelsToDisplay + '&weblocationnodeid=' + webLocationId + '&clearPosition=' + clearPosition,
            cache: false,
            success: function (hotelresults) {
                if (hotelresults.length > 0) {

                    buildHotelResults(hotelresults, starRating, webLocationId, numHotelsToDisplay, 'N');

                    if (obj) {
                        var elem = document.getElementById(obj);
                        if (elem) {
                            switch (obj) {
                                case 'ctl00_leftContent_fivestarhead':
                                    elem.onclick = function () { toggleElement('fiveStarHotelHolder'); }
                                    $("#loading5star").hide();
                                    break;
                                case 'ctl00_leftContent_fourstarhead':
                                    elem.onclick = function () { toggleElement('fourStarHotelHolder'); }
                                    $("#loading4star").hide();
                                    break;
                                case 'ctl00_leftContent_threestarhead':
                                    elem.onclick = function () { toggleElement('threeStarHotelHolder'); }
                                    $("#loading3star").hide();
                                    break;
                                case 'ctl00_leftContent_budgetstarhead':
                                    elem.onclick = function () { toggleElement('budgetStarHolder'); }
                                    $("#loadingbudgetstar").hide();
                                    break;
                                default:
                                    if (elem) {
                                        elem.parentNode.removeChild(elem);
                                    }

                                    $("#loading5star").hide();
                                    $("#loading4star").hide();
                                    $("#loading3star").hide();
                                    $("#loadingbudgetstar").hide();
                            }

                            mainHotelHolder.style.minHeight = "auto";

                            switch (obj) {
                                case 'showMore5':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                                case 'showMore4':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                                case 'showMore3':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                                case 'budgetMore':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                            }

                        }
                    }
                }
            },
            error: function (feedback) {
                return;
            }
        });

    }

}

function buildHotelResults(hotelresults, starRating, webLocationId, searchCount, isFiltered, hotelDesc) {

    var mainHotelHolder;
    var holderforhotelDiv, hotelDiv, urlLink, img, hotelName, link, description, readMoreLink, spanPrice, divPrice, spanPriceInner, mainPriceSpan, showMoreDiv, showMoreLink, loadingStarDiv, loaderImg, numHotelToDisplay
    var imageSet = 'N';

    if (starRating > 0 && hotelDesc != 'Y') {

        switch (starRating) {
            case 5:
                mainHotelHolder = document.getElementById('fiveStarHotelHolder');
                mainHotelHolder.style.display = 'block';
                if (!document.getElementById('loading5star')) {
                    loadingStarDiv = document.createElement('div');
                    loadingStarDiv.className = 'loadinghotels';
                    loadingStarDiv.id = "loading5star";
                }
                break;
            case 4:
                mainHotelHolder = document.getElementById('fourStarHotelHolder');
                mainHotelHolder.style.display = 'block';
                if (!document.getElementById('loading4star')) {
                    loadingStarDiv = document.createElement('div');
                    loadingStarDiv.className = 'loadinghotels';
                    loadingStarDiv.id = "loading4star";
                }
                break;
            case 3:
                mainHotelHolder = document.getElementById('threeStarHotelHolder');
                mainHotelHolder.style.display = 'block';
                if (!document.getElementById('loading3star')) {
                    loadingStarDiv = document.createElement('div');
                    loadingStarDiv.className = 'loadinghotels';
                    loadingStarDiv.id = "loading3star";
                }
                break;
            case 2:
                mainHotelHolder = document.getElementById('budgetStarHolder');
                mainHotelHolder.style.display = 'block';

                if (!document.getElementById('loadingbudgetstar')) {
                    loadingStarDiv = document.createElement('div');
                    loadingStarDiv.className = 'loadinghotels';
                    loadingStarDiv.id = "loadingbudgetstar";
                }
                break;
        }
    } else {
        mainHotelHolder = document.getElementById('otherhotelholder');
        mainHotelHolder.style.display = 'block';
    }

    for (var i = 0; i <= hotelresults.length - 1; i++) {

        holderforhotelDiv = document.createElement('div');
        holderforhotelDiv.className = 'holderforhotel';

        hotelDiv = document.createElement('div');
        hotelDiv.className = 'hotel';

        urlLink = document.createElement('a');
        urlLink.href = hotelresults[i].HotelUrl;

        img = document.createElement('img');
        img.src = hotelresults[i].ImageUrl;
        img.width = 80;
        img.height = 60;

        urlLink.appendChild(img);

        hotelName = document.createElement('h3');
        hotelName.id = 'prop_' & hotelresults[i].GlobalPropertyNodeId;
        hotelName.className = 'hotelName';

        link = document.createElement('a');
        link.href = hotelresults[i].HotelUrl;
        link.innerHTML = hotelresults[i].HotelName;

        hotelName.appendChild(link);

        description = document.createElement('p');
        description.innerHTML = hotelresults[i].LocationText + '...';

        readMoreLink = document.createElement('a');
        readMoreLink.className = 'readmore';
        readMoreLink.href = hotelresults[i].HotelUrl;
        readMoreLink.innerHTML = '&nbsp; Read more';

        description.appendChild(readMoreLink);

        spanPrice = document.createElement('span');
        spanPrice.className = 'price';

        divPrice = document.createElement('div');

        spanPriceInner = document.createElement('span');
        spanPriceInner.className = 'innerprice';
        spanPriceInner.innerHTML = 'fr &pound;'

        mainPriceSpan = document.createElement('span');
        mainPriceSpan.id = 'price' & hotelresults[i].GlobalPropertyNodeId;
        mainPriceSpan.innerHTML = hotelresults[i].BestPrice + ' <span class="addtionaltxt">per room night</span>';

        if (hotelresults[i].DiscountText) {
            divPrice.innerHTML = hotelresults[i].DiscountText;
        }

        spanPriceInner.appendChild(mainPriceSpan)
        divPrice.appendChild(spanPriceInner);
        spanPrice.appendChild(divPrice);


        if (hotelresults[i].SearchResultsCount > searchCount && i == (hotelresults.length - 1)) {
            if (i != hotelresults[i].SearchResultsCount - 1) {
                showMoreDiv = document.createElement('div');
                showMoreDiv.className = "clear filterstar"
                if (hotelDesc == 'Y') {
                    showMoreDiv.id = 'morehotels';
                } else {
                    showMoreDiv.id = 'showExtra' + starRating;
                }

                if (hotelresults.length > 9) {
                    showMoreLink = document.createElement('a');

                    if (starRating == 2) {
                        showMoreLink.innerHTML = 'More budget hotels >';
                    } else if (starRating >= 4) {
                        showMoreLink.innerHTML = 'Show ' + (hotelresults[i].SearchResultsCount - 30) + ' more >';
                    } else {
                        showMoreLink.innerHTML = 'More ' + starRating + ' star hotels >';
                    }

                    if (starRating >= 4) {
                        numHotelToDisplay = (hotelresults[i].SearchResultsCount - 30)
                    } else {
                        numHotelToDisplay = 10
                    }

                    if (hotelDesc == 'Y') {
                        if (isFiltered == 'Y') {
                            showMoreLink.href = 'javascript:getHotelsForHotelDesc(' + "'E'," + starRating + ',' + numHotelToDisplay + ',' + webLocationId + ',' + "'" + showMoreDiv.id + "'" + ", 'Y'" + "," + hotelresults[hotelresults.length - 1].BedsLocationId + ')';
                        } else {
                            showMoreLink.href = 'javascript:getHotelsForHotelDesc(' + "'E'," + starRating + ',' + numHotelToDisplay + ',' + webLocationId + ',' + "'" + showMoreDiv.id + "'" + ')';
                        }
                    } else {
                        if (isFiltered == 'Y') {
                            showMoreLink.href = 'javascript:getHotels(' + "'E'," + starRating + ',' + numHotelToDisplay + ',' + webLocationId + ',' + "'" + showMoreDiv.id + "'" + ", 'Y'" + "," + hotelresults[hotelresults.length - 1].BedsLocationId + ')';
                        } else {
                            showMoreLink.href = 'javascript:getHotels(' + "'E'," + starRating + ',' + numHotelToDisplay + ',' + webLocationId + ',' + "'" + showMoreDiv.id + "'" + ')';
                        }
                    }

                    showMoreDiv.appendChild(showMoreLink)

                }
            }
        }

        hotelDiv.appendChild(urlLink);
        hotelDiv.appendChild(hotelName);
        hotelDiv.appendChild(description);
        hotelDiv.appendChild(spanPrice);
        holderforhotelDiv.appendChild(hotelDiv);
        mainHotelHolder.appendChild(holderforhotelDiv);
        if (loadingStarDiv) {
            if (imageSet == 'N') {
                loaderImg = document.createElement('img');
                loaderImg.src = '/images/hotels_loader_blue.gif';
                loaderImg.width = 90;
                loaderImg.height = 90;
                imageSet = 'Y';
                loadingStarDiv.appendChild(loaderImg);
            }
            mainHotelHolder.appendChild(loadingStarDiv);
        }
        
        if (showMoreDiv) {
            showMoreDiv.style.display = 'block';
            mainHotelHolder.appendChild(showMoreDiv);
        }
    }

    if (starRating > 0) {
        switch (starRating) {
            case 5:
//                if (document.getElementById('fiveStarHotelHolderDisplay')) {
//                    $('#fiveStarHotelHolderDisplay').empty();
//                }
                break;
            case 4:
                if (document.getElementById('fourStarHotelHolderDisplay')) {
                    $('#fourStarHotelHolderDisplay').empty();
                }
                break;
            case 3:
                if (document.getElementById('threeStarHotelHolderDisplay')) {
                    $('#threeStarHotelHolderDisplay').empty();
                }
                break;
            case 2:
                if (document.getElementById('budgetStarHotelHolderDisplay')) {
                    $('#budgetStarHotelHolderDisplay').empty();
                }
                break;
            default:
                //
                break;
        }
    }
}

function getHotelsForHotelDesc(hotelDisplayMode, starRating, numHotelsToDisplay, webLocationId, obj, isFiltered, bedsLocationId) {

    var mainHotelHolder;

    if (starRating > 0 && numHotelsToDisplay > 0 && webLocationId > 0) {

        if (mainHotelHolder) {
            mainHotelHolder.style.display = 'block';
        }

        if (obj) {
            if (document.getElementById(obj)) {
                document.getElementById(obj).style.minHeight = 'auto';
            } else {
                mainHotelHolder.style.display = 'none';
            }
        }

        if (document.getElementById('showmore')) {
            document.getElementById('showmore').style.display = 'none';
            clearPosition = 'N';
            mainHotelHolder = document.getElementById('otherhotelholder');
            $("#hotelloading").show();
        }


        if (hotelDisplayMode.toUpperCase() === 'D') {
            clearPosition = 'Y';

        }

        jQuery.ajax({
            url: '/utility/hotelresultsbystarrating.aspx?starrating=' + starRating + '&numhotelstodisplay=' + numHotelsToDisplay + '&weblocationnodeid=' + webLocationId + '&isFiltered=' + isFiltered + '&bedsLocationId=' + bedsLocationId + '&clearPosition=' + clearPosition,
            cache: false,
            success: function (hotelresults) {
                if (hotelresults.length > 0) {

                    if (isFiltered && isFiltered == 'Y') {
                        buildHotelResults(hotelresults, starRating, webLocationId, numHotelsToDisplay, 'Y', 'Y');
                    } else {
                        buildHotelResults(hotelresults, starRating, webLocationId, numHotelsToDisplay, 'N', 'Y');
                    }

                    if (obj) {
                        var elem = document.getElementById(obj);
                        if (elem) {
                            switch (obj) {
                                case 'ctl00_leftContent_fivestarhead':
                                    elem.onclick = function () { toggleElement('fiveStarHotelHolder'); }
                                    $("#loading5star").hide();
                                    break;
                                case 'ctl00_leftContent_fourstarhead':
                                    elem.onclick = function () { toggleElement('fourStarHotelHolder'); }
                                    $("#loading4star").hide();
                                    break;
                                case 'ctl00_leftContent_threestarhead':
                                    elem.onclick = function () { toggleElement('threeStarHotelHolder'); }
                                    $("#loading3star").hide();
                                    break;
                                case 'ctl00_leftContent_budgetstarhead':
                                    elem.onclick = function () { toggleElement('budgetStarHolder'); }
                                    $("#loadingbudgetstar").hide();
                                    break;
                                default:
                                    if (elem) {
                                        elem.parentNode.removeChild(elem);
                                    }

                                    $("#loading5star").hide();
                                    $("#loading4star").hide();
                                    $("#loading3star").hide();
                                    $("#loadingbudgetstar").hide();
                                    $("#hotelloading").hide();
                            }

                            mainHotelHolder.style.minHeight = "auto";
                            mainHotelHolder.style.display = 'block';

                            switch (obj) {
                                case 'showMore5':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                                case 'showMore4':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                                case 'showMore3':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                                case 'budgetMore':
                                    if (document.getElementById(obj)) {
                                        document.getElementById(obj).style.display = 'none';
                                    }
                                    break;
                            }

                        }
                    }
                }
            },
            error: function (feedback) {
                return;
            }
        });

    }

}

function findHashInUrl(loactionNodeId) {

    var hasUrl = location.hash;

    switch (hasUrl.toLowerCase()) {
        case '#4star':
            getHotels('E', 4, 10, loactionNodeId,'ctl00_leftContent_fourstarhead')
            break;
        case '#3star':
            getHotels('E', 3, 10, loactionNodeId, 'ctl00_leftContent_threestarhead');
            break;
        case '#budget':
            getHotels('E', 2, 10, loactionNodeId, 'ctl00_leftContent_budgetstarhead')
            break;
    }

}

////////////// END /////////////